/*
 * @Author: Src
 * @Date: 2026-09-08 08:45:58
 * @LastEditTime: 2026-09-14 10:51:47
 * @LastEditors: Src
 * @FilePath: /work-station/src/services/supply.service.ts
 * @Description: 模块
 */
import { inject, injectable } from 'inversify';
import HttpClient from './http.service';

@injectable()
export default class SupplyService {
  @inject(HttpClient)
  protected http!: HttpClient;


  /**
   * 平台销售单列表
   * @param params
   * @returns
   * @description 平台销售单列表
   */
  async getSaleOrderList(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get('/scm/plat/sale/order/list', { params,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 平台销售单详情
   * @param params
   * @returns
   * @description 平台销售单详情
   */

  async getSaleOrderDetail(orderNo: string) {
    try {
      const res = await this.http.get(`/scm/plat/sale/order/detail/${orderNo}`) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 确认收款
   * @param params
   * @returns
   * @description 确认收款
   */
  async postConfirmReceipt(params: any) {
    try {
      const res = await this.http.post('/scm/plat/confirm/receipt', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 上传平台销售订单（经销商订单）发票
   * @param params
   * @returns
   * @description 上传平台销售订单（经销商订单）发票
   */
  async postUploadPlatformSaleOrderInvoice(params: any) {
    try {
      const res = await this.http.post('/scm/plat/upload/order/invoice', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 平台采购单列表
   * @param params
   * @returns
   * @description 平台采购单列表
   */
  async getPurchaseOrderList(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get('/scm/plat/order/list', { params,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 平台采购单详情
   * @param params
   * @returns
   * @description 平台采购单详情
   */
  async getPlatOrderDetail(params: any) {
    try {
      const res = await this.http.get('/scm/plat/order/detail', { params }) as string;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 平台采购单商品列表
   * @param params
   * @returns
   * @description 平台采购单商品列表
   */
  async getPurchaseOrderCommodities(params: any) {
    try {
      const res = await this.http.get('/scm/plat/order/commodities', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 平台销售单归集接口
   * @param params
   * @returns
   * @description 平台销售单归集接口
   */
  async postPlatCollect(params: any) {
    try {
      const res = await this.http.post('/scm/plat/collect', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 平台采购单发起请款接口
   * @param params
   * @returns
   * @description 平台采购单发起请款接口
   */
  async postPlatSavePo(params: any) {
    try {
      const res = await this.http.post('/scm/plat/save/po', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 可归集的平台销售单接口
   * @param params
   * @returns
   * @description 可归集的平台销售单接口
   */
  async getPlatCollectibleOrders(params: any) {
    try {
      const res = await this.http.get('/scm/plat/collectible/orders', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 可归集的平台销售单商品列表
   * @param params
   * @returns
   * @description 可归集的平台销售单商品列表
   */
  async getPlatCollectibleOrderCommodity(params: any) {
    try {
      const res = await this.http.post('/scm/plat/collectible/order/commodity', params) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 上传平台采购单发票
   * @param params
   * @returns
   * @description 上传平台采购单发票
   */
  async postUploadPlatInvoice(params: any) {
    try {
      const res = await this.http.post('/scm/plat/upload/plat/invoice', params) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 添加分销商
   * @param params
   * @returns
   * @description 添加分销商
   */
  async postAddDistributor(params: any) {
    try {
      const res = await this.http.post('/scm/distributor/add', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 经销商列表
   * @param params
   * @returns
   * @description 经销商列表
   */
  async getDistributorList(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get('/scm/distributor/list', { params,
         data: {
          loadingEl,
        },
       }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 搜索分销商列表接口
   * @param params
   * @returns
   * @description 搜索分销商列表接口
   */
  async getDistributorSearch(params: any) {
    try {
      const res = await this.http.get('/scm/distributor/search', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 经销商详情接口
   * @param sdCode
   * @returns
   * @description 经销商详情接口
   */
  async getDistributorDetail(sdCode: any) {
    try {
      const res = await this.http.get(`/scm/distributor/${sdCode}/detail`) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 编辑经销商信息
   * @param params
   * @returns
   * @description 编辑经销商信息
   */
  async postEditDistributor(sdCode: string, params: any) {
    try {
      const res = await this.http.post(`scm/distributor/${sdCode}/edit`, params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 收货人列表
   * @param params
   * @returns
   * @description 收货人列表
   */
  async getDeliveryList(params: any) {
    try {
      const res = await this.http.get('/scm/distributor/delivery/list', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }


    /**
   * 创建收货人信息
   * @param params
   * @returns
   * @description 创建收货人信息
   */
  async postAddDelivery(params: any) {
    try {
      const res = await this.http.post('/scm/distributor/delivery/add', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 更新收货人信息状态
   * @param params
   * @returns
   * @description 更新收货人信息状态
   */
  async postEditDelivery(id: string, params: any) {
    try {
      const res = await this.http.post(`/scm/distributor/delivery/${id}/edit`, params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 收货人详情接口
   * @param id
   * @returns
   * @description 收货人详情接口
   */
  async getDeliveryDetail(id: string) {
    try {
      const res = await this.http.get(`/scm/distributor/delivery/${id}/detail`) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 经销商采购单列表
   * @param params
   * @returns
   * @description 经销商采购单列表
   */
  async getDistributorPurchaseOrderList(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get('/scm/distributor/purchase_order/list', { params,
         data: {
          loadingEl,
        },
       }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 获取经销商采购单编号
   * @param params
   * @returns
   * @description 获取经销商采购单编号
   */
  async getDistributorPurchaseOrderGenerateOrderNo(params: any) {
    try {
      const res = await this.http.get('/scm/distributor/purchase_order/generate/order_no', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 根据类目查询商品信息
   * @param params
   * @returns
   * @description 根据类目查询商品信息
   */
  async getCommodityListByCategory(params: any) {
    try {
      const res = await this.http.get('/scm/commodity/list/by/category', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }
  /**
   * 根据id查询商品信息
   * @param params
   * @returns
   * @description 根据id查询商品信息
   */
  async getCommodityListByIds(params: any) {
    try {
      const res = await this.http.get('/scm/commodity/list/by/ids', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 经销商订单详情接口
   * @param params
   * @returns
   * @description 经销商订单详情接口
   */
  async getDistributorPurchaseOrderDetail(orderNo: string) {
    try {
      const res = await this.http.get(`/scm/distributor/purchase_order/${orderNo}/detail`) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 创建经销商采购单
   * @param params
   * @returns
   * @description 创建经销商采购单
   */
  async postDistributorPurchaseOrderAdd(params: any) {
    try {
      const res = await this.http.post('/scm/distributor/purchase_order/add', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 订单编号查询商品信息
   * @param params
   * @returns
   * @description 订单编号查询商品信息
   */
  async getCommodityDetailByOrder(params: any) {
    try {
      const res = await this.http.get('/scm/commodity/detail/by/order', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }
  /**
   * 上传支付款凭证
   * @param params
   * @returns
   * @description 上传支付款凭证
   */
  async postUploadPaymentVoucher(params: any) {
    try {
      const res = await this.http.post('/scm/distributor/voucher/create', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 经销商 签收物流信息
   * @param params
   * @returns
   * @description 经销商 签收物流信息
   */
  async postDistributorShipmentSign(params: any) {
    try {
      const res = await this.http.post('/scm/distributor/shipment/sign', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 商品列表
   * @param params
   * @returns
   * @description 商品列表
   */
  async getCommodityList(params: any) {
    try {
      const res = await this.http.get('/scm/commodity/commodity_list', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 商品分类配置
   * @returns
   * @description 商品分类配置
   */
  async getCommodityCateConfig(params: any) {
    try {
      const res = await this.http.get('/scm/commodity/cate_config', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }
  /**
   * 配置项目里带关联项目的选项
   * @returns
   * @description 配置项目里带关联项目的选项
   */
  async getCommodityCateOptions(params: any) {
    try {
      const res = await this.http.get('/scm/commodity/cate_options', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }
  /**
   * 商品详情
   * @param params
   * @returns
   * @description 商品详情
   */
  async getCommodityDetail(params: any) {
    try {
      const res = await this.http.get('/scm/commodity/commodity_detail', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 商品编辑
   * @param params
   * @returns
   * @description 商品编辑
   */
  async postCommodityEdit(params: any) {
    try {
      const res = await this.http.post('/scm/commodity/commodity_edit', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 商品上架下架
   * @param params
   * @returns
   * @description 商品上架下架
   */
  async postCommodityUpdateStatus(params: any) {
    try {
      const res = await this.http.post('/scm/commodity/update_status', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 供应商列表
   * @param params
   * @returns
   * @description 供应商列表
   */
  async getSupplierList(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get('/scm/supplier/list', { params,
         data: {
          loadingEl,
        },
       }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 供应商详情
   * @param params
   * @returns
   * @description 供应商详情
   */
  async getSupplierDetail(params: any) {
    try {
      const res = await this.http.get('/scm/supplier/detail', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 供应商编辑
   * @param params
   * @returns
   * @description 供应商编辑
   */
  async postSupplierEdit(params: any) {
    try {
      const res = await this.http.post('/scm/supplier/edit', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }
  /**
   * 供应商上架下架
   * @param params
   * @returns
   * @description 供应商上架下架
   */
  async postSupplierUpdateStatus(params: any) {
    try {
      const res = await this.http.post('/scm/supplier/update_status', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 方案list
   * @param params
   * @returns
   * @description 方案list
   */
  async getCommodityPlanList(params: any) {
    try {
      const res = await this.http.get('/scm/commodity_plan/list', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 方案审核check
   * @param params
   * @returns
   * @description 方案审核
   */
  async postCommodityPlanCheck(params: any) {
    try {
      const res = await this.http.post('/scm/commodity_plan/check', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**

   * 方案详情
   * @param params
   * @returns
   * @description 方案详情
   */
  async getCommodityPlanDetail(params: any) {
      try {
        const res = await this.http.get('/scm/commodity_plan/detail', { params }) as any;
        return res;
      } catch (error) {
        return '';
      }
  }


/**
 * 商品方案编辑
 * @param params
 * @returns
 * @description 商品方案
 */
  async postCommodityPlanEdit(params: any) {
    try {
      const res = await this.http.post('/scm/commodity_plan/edit', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 方案上架下架
   * @param params
   * @returns
   * @description 方案上架下架
   */
  async postCommodityPlanUpdateStatus(params: any) {
    try {
      const res = await this.http.post('/scm/commodity_plan/update_status', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 获取发票列表
   * @param params
   * @returns
   * @description 获取发票列表
   */
  async getInvoiceList(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get('/scm/plat/invoice/list', { params,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 获取发票详情
   * @param params
   * @returns
   * @description 获取发票详情
   */
  async getInvoiceDetail(params: any) {
    try {
      const res = await this.http.get('/scm/plat/invoice/detail', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 经销商发票列表
   * @param params
   * @returns
   * @description 经销商发票列表
   */
  async getDistributorInvoiceList(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get('/scm/distributor/invoice/list', { params,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 经销发票详情
   * @param params
   * @returns
   * @description 经销发票详情
   */
  async getDistributorInvoiceInfo(params: any) {
    try {
      const res = await this.http.get('/scm/distributor/invoice/info', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 供应商订单
   * @param params
   * @returns
   * @description 订单列表
   */
  async getPlatOrderList(params: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get('/scm/plat_order/list', { params,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }


/**
 * 订单详情
 * @param params
 * @returns
 * @description 订单详情
 */
  async getPlatDetail(params: any) {
    try {
      const res = await this.http.get('/scm/plat_order/detail', { params }) as any;
      return res;
    } catch (error) {
      return '';
    }
  }

  /**
   * 订单发货
   * @param params
   * @returns
   * @description 订单发货
   */
  async postPlatOrderShip(params: any) {
    try {
      const res = await this.http.post('/scm/plat_order/ship', params) as string;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 经销商发货
   * @param params
   * @returns
   * @description 经销商发货
   */
  async postDistributorDelivery(distributorId: any) {
    try {
      const res = await this.http.get(`scm/distributor/delivery/${distributorId}/default`) as string;
      return res;
    } catch (error) {
      return '';
    }
  }
}
